import { Button, FormGroup, Loader } from "@shltelemedicine/shl-ui-lib";
import { useState } from "react";
import { Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { FormattedMessage } from "react-intl";
import { emailPattern } from "../../../constants";
import useForgotPassword from "../../../hooks/useForgotPassword";
import AlertModal from "../../Shared/AlertModal/AlertModal";
import TextFormInput from "../../Shared/TextInput/TextFormInput";
import SupportModal from "../../SupportModal/SupportModal";
import styles from "./ForgotPasswordForm.module.css";
type ForgotPasswordFormInput = { email: string };

type ForgotPasswordProps = {
  username?: string;
  mobile?: "0" | "1" | null;
};

const ForgotPasswordForm = ({ username, mobile }: ForgotPasswordProps) => {
  const {
    handleSubmit,
    control,
    formState: { errors: formErrors },
  } = useForm<ForgotPasswordFormInput>({ defaultValues: { email: username } });

  const {
    forgotPassword,
    loading,
    alertProps,
    alertMessage,
    emailSubmitted,
  } = useForgotPassword();

  const { support, ...alertPropsWithoutSupport } = alertProps;

  const [showSupportModal, setShowSupportModal] = useState(false);

  const handleCloseSupportModal = () => setShowSupportModal(false);

  const onSubmit = async ({ email }: ForgotPasswordFormInput) => {
    await forgotPassword(email, mobile);
  };

  return (
    <>
      <Form
        className="z-index-front font-md align-self-center m-2"
        onSubmit={handleSubmit(onSubmit)}
      >
        {loading && (
          <div className="p-sm-2 mb-sm-3">
            <Loader />
          </div>
        )}
        {!loading && (
          <div className={`${styles.textInfo} align-items-center mb-md-4 mb-2`}>
            <FormattedMessage
              id={`${
                !emailSubmitted
                  ? "FORGOT_PASSWORD.RESET_INFO"
                  : "FORGOT_PASSWORD.CONFIRMATION_RESET_INFO"
              }`}
              defaultMessage={`${
                !emailSubmitted
                  ? "Reset Password.<br></br>Enter the email address used to log into Smartheart.<br></br>A link will be sent to reset your password."
                  : "Email sent.<br></br>A reset password email has been sent.<br></br>Please check your inbox, if you do not receive an email please contact customer service."
              }`}
              values={{
                br: () => <br></br>,
              }}
            />
          </div>
        )}

        <FormGroup
          label={
            <>
              <FormattedMessage id="USER.EMAIL" defaultMessage="Email" />:
            </>
          }
          input={
            <div className="d-md-flex">
              <TextFormInput
                name={"email"}
                control={control}
                rules={{
                  required: true,
                  pattern: emailPattern,
                }}
                input={{
                  className: styles.input,
                  isInvalid: !!formErrors?.email,
                }}
              />
              <Button
                type="submit"
                bgColor="#435FC5"
                className="px-4 mx-md-2 mt-3 mt-md-0 mx-auto"
              >
                SUBMIT
              </Button>
            </div>
          }
        />
      </Form>
      <SupportModal show={showSupportModal} onClose={handleCloseSupportModal} />
      <AlertModal {...alertPropsWithoutSupport}>{alertMessage}</AlertModal>
    </>
  );
};

export default ForgotPasswordForm;
